export const APPLICATION_JSON = "application/json";
export const MULTIPART = "multipart/form-data";
